import { PropsWithChildren } from "react";
import { CustomYAxisTooltip } from "../CustomYAxisTooltip.tsx";
import { ChartTooltipState } from "../../../../types.js";

type Props = PropsWithChildren<{
  tooltip: ChartTooltipState;
  label: string;
}>;

const ChartWithTooltip = ({ children, tooltip, label }: Props) => {
  return (
    <div style={{ position: "relative" }}>
      {children}
      {/* Custom Tick Tooltip */}
      <CustomYAxisTooltip tooltip={tooltip} label={label} />
    </div>
  );
};

export default ChartWithTooltip;
